module.exports = __webpack_public_path__ + "static/couch-927fddc6d015846f84ebb661865e2728.jpg";